module.exports = __webpack_public_path__ + "img/16m009-03.3d0b043e.jpg";